import React from 'react';
import { UserCircle } from 'lucide-react';
export function CustomerLogin() {
  return <div className="mt-12 bg-white border border-gray-200 rounded-lg p-6 max-w-md" data-id="element-1">
      <div className="flex items-center gap-2 mb-4" data-id="element-2">
        <UserCircle className="w-5 h-5 text-gray-500" data-id="element-3" />
        <h3 className="text-lg font-bold text-brand-charcoal" data-id="element-4">
          Return customers log in here.
        </h3>
      </div>

      <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-5">
        <div data-id="element-6">
          <label htmlFor="email" className="sr-only" data-id="element-7">
            Email
          </label>
          <input type="email" id="email" placeholder="Email" className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-brand-darkGold focus:ring-1 focus:ring-brand-darkGold" data-id="element-8" />
        </div>
        <div data-id="element-9">
          <label htmlFor="password" className="sr-only" data-id="element-10">
            Password
          </label>
          <input type="password" id="password" placeholder="Password" className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-brand-darkGold focus:ring-1 focus:ring-brand-darkGold" data-id="element-11" />
        </div>
        <div className="flex items-center gap-3" data-id="element-12">
          <button type="submit" className="bg-brand-lightGold hover:bg-brand-darkGold border border-brand-darkGold text-black font-semibold px-6 py-2 rounded text-sm transition-colors" data-id="element-13">
            Log In
          </button>
          <button type="button" className="bg-brand-lightGold hover:bg-brand-darkGold border border-brand-darkGold text-black font-semibold px-6 py-2 rounded text-sm transition-colors" data-id="element-14">
            Find Pass
          </button>
        </div>
      </form>
    </div>;
}